import { isCapabilityEnabled } from 'owa-capabilities';
import { bizchatDrawerCapability } from 'owa-capabilities-definitions/lib/bizchatDrawerCapability';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';
import { logBizChatSidePaneEntrypoint } from 'owa-bizchat-shared/lib/utils/logBizChatSidePaneEntrypoint';
import { prefetchBizChatAuthTokens } from 'owa-bizchat-shared/lib/utils/prefetchBizChatAuthTokens';
import { prefetchSSRTokenForAutoOpen } from 'owa-bizchat-shared/lib/utils/prefetchSSRTokenForAutoOpen';
import {
    hasCopilotChatDrawerCanvasWidthMeasurement,
    markDisableAutoFocusForCurrentOpen,
    openCopilotChatDrawer,
    shouldCopilotChatDrawerUseFullCanvas,
} from 'owa-copilot-chat-drawer-store';
import openFlexPaneHelper from 'owa-app-pane-group-utils/lib/helpers/openFlexPaneHelper';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

const CHAT_COPILOT_FLEXPANE_ID = 'ChatCopilot';

/**
 * Handles auto-opening of Copilot Chat pane with telemetry and prefetch
 * @returns false when auto-open should stay pending until prerequisites are known.
 */
export function handleCopilotChatAutoOpen(): boolean {
    const isBizChatSidepaneEnabled = isBizchatSidepaneEnabled();
    if (isBizChatSidepaneEnabled === undefined) {
        return false;
    }
    if (!isBizChatSidepaneEnabled) {
        return true;
    }

    if (isGlobalFeatureEnabled('mon-copilot-bizchat-disable-sticky-open')) {
        return true;
    }

    const isBizchatDrawerEnabled = isCapabilityEnabled(bizchatDrawerCapability);
    if (isBizchatDrawerEnabled) {
        if (!hasCopilotChatDrawerCanvasWidthMeasurement(window)) {
            return false;
        }

        // Stage 3/full-canvas auto-open is intentionally skipped for this session.
        if (shouldCopilotChatDrawerUseFullCanvas(window)) {
            return true;
        }
    }

    const mailboxInfo = getModuleContextMailboxInfo();

    logBizChatSidePaneEntrypoint(
        /* source */ 'StickyOpen',
        /* mailboxInfo */ mailboxInfo,
        /* targetWindow */ window
    );
    void prefetchBizChatAuthTokens('BizChatSidePaneStickyOpen');
    void prefetchSSRTokenForAutoOpen(mailboxInfo);

    if (isBizchatDrawerEnabled) {
        markDisableAutoFocusForCurrentOpen();
        openCopilotChatDrawer(window, mailboxInfo);
    } else {
        openFlexPaneHelper(CHAT_COPILOT_FLEXPANE_ID, 'chatCopilot');
    }

    return true;
}
